<template>
  <div class="mt-4">
    <div class="mb-4">
      <h4>TNM Configuration</h4>
    </div>

    <b-table sticky-header :items="mappingModel" :fields="fields">
      <template #thead-top="data">
        <b-tr>
          <b-th variant="primary" colspan="3">TNM Staging</b-th>
          <b-th variant="secondary" colspan="2">OncoTrust Treatment Group</b-th>
        </b-tr>
      </template>

      <template #cell(nsclc)="data">
        <b-dropdown
          size="sm"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <template #button-content>
            {{ data.value.name }}
            <b-icon-pen font-scale="0.75"></b-icon-pen>
          </template>
          <b-dropdown-item
            v-for="group in nsclcGroups"
            :key = "group"
            href="#"
            @click="updateGroup(data, group.id, 'nsclc')"
          >
            {{ group.name }}
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <template #cell(sclc)="data">
        <b-dropdown
          size="sm"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <template #button-content>
            {{ data.value.name }}
            <b-icon-pen font-scale="0.75"></b-icon-pen>
          </template>
          <b-dropdown-item
            v-for="group in sclcGroups"
            :key = "group"
            href="#"
            @click="updateGroup(data, group.id, 'sclc')"
          >
            {{ group.name }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { HttpHandler } from "@/http/HttpHandler";
import AppSubmitButton from "@/components/AppSubmitButton.vue";
import { TnmMappingModel } from "@/entities/admin/TnmMappingModel";
import { GroupingMapping } from "@/entities/admin/TnmGroupModel";
import store from "@/store/index";

@Component({
  components: {
    AppSubmitButton
  }
})
export default class TnmConfiguration extends Vue {
  private fields = [
    { key: 'tumour', sortable: true },
    { key: 'node', sortable: true },
    { key: 'metastases', sortable: true },
    { key: 'nsclc', sortable: false },
    { key: 'sclc', sortable: false },
  ];

  mappingModel: TnmMappingModel[] = [];
  nsclcGroups: GroupingMapping[] = [];
  sclcGroups: GroupingMapping[] = [];

  private async updateGroup(data: any, groupingId: string, type: string) {
    const httpHandler = new HttpHandler(store);
    await httpHandler.setTnmMapping(
      data.item.tumour,
      data.item.node,
      data.item.metastases,
      type,
      groupingId
    );

    this.mappingModel = await httpHandler.getTnmMapping();
  }

  async created() {
    const httpHandler = new HttpHandler(store);
    this.mappingModel = await httpHandler.getTnmMapping();
    const groups = await httpHandler.getTnmGroups();
    this.nsclcGroups = groups.nsclc;
    this.sclcGroups = groups.sclc;
  }
}
</script>

<style scoped>
.b-table-sticky-header {
  max-height: calc(100vh - 15rem);
}
</style>
